import React from 'react';
import TTLProxy from "../../../common/TTLAsyncProxy";
import {MiscEndpoints} from "../../../common/ProxyEndpoints";
import {Alert, Button, ButtonGroup} from 'reactstrap';
import Utils from "../../../common/Utils";
import ProgressBar from 'react-md-progress-bar';
import MDProgress from 'react-md-progress-bar';
import JsonTable from "../../../components/ReactJsonTable/ReactJsonTable";
import DocumentTitle from 'react-document-title';
import SmartDialog from "../../../components/SmartDialog";
import {Form, Formik} from "formik";
import MDSpinner from 'react-md-spinner';
import FormInput from "../../../components/FormInput";
import HTML from '../../../common/HtmlHelpers';
import * as Yup from 'yup';
import TimeAgo from "../../../common/TimeAgo";
import PropTypes from 'prop-types';

const EditSettingValidationSchema = Yup.object().shape({
    name: Yup.string().notRequired().label("Name"),
    category: Yup.string().notRequired().label("Category"),
    value: Yup.string().required('Please enter a valid value').label("Value"),
});

const Styles = {

    contentFrame:{
        padding: '1.5rem',
        backgroundColor: 'white'
    },

    heading: {
        marginTop: 10,
        marginBottom: 10
    }
};

class EditSettingDialog extends React.Component{

    static propTypes = {
        onEdited: PropTypes.func
    };

    constructor(props){
        super(props);
        this.state = EditSettingDialog.getInitialState({});
        this.proxy = TTLProxy.getInstance();
    }

    static getInitialState(state){

        return {
            setting: state.setting || null,
        };

    }

    async onEditSetting({ id , value }){

        try {

            const res = await this.proxy.processRequest(MiscEndpoints.updateSetting(id, {value}));
            if(res.ok){

                //  update successful
                HTML.toastSuccess("Setting updated successfully");

                //  invoke edited
                if(this.props.onEdited){
                    this.props.onEdited();
                }

                //
                this._dlg.hide();
            }

        }
        catch (e) {
            HTML.toastError(Utils.getResponseError(e));
        }


    }

    show(setting){

        this.setState(EditSettingDialog.getInitialState({ setting }),() => {
            this._dlg.show();
        });

    }

    render(){

        const { setting } = this.state;
        return <SmartDialog ref={r => this._dlg = r} title="Edit Setting">

            <Formik validationSchema={EditSettingValidationSchema}
                    onSubmit={async (values,{ setSubmitting  }) => {

                        try{
                            await this.onEditSetting(values);
                        }
                        catch (e) {
                        }
                        finally {
                            setSubmitting(false);
                        }

                    }}
                    enableReinitialize
                    initialValues={setting}>
                {({ isValid , isSubmitting }) => {

                    return <Form>

                        {isValid && <Alert color={"info"}><i className="fa fa-info"/> Other dependent settings will be adjusted accordingly</Alert>}

                        <label>Description</label>
                        <p style={{
                            backgroundColor: "#eaeaea",
                            padding: 10
                        }}>{setting.description}</p>

                        <FormInput name="name"
                                   type="text"
                                   title="Name"
                                   placeholder="Enter setting name"
                                   disabled/>

                        <FormInput name="value"
                                   type="text"
                                   placeholder="Enter setting value"
                                   disabled={isSubmitting}
                                   title="Value"/>


                        <hr/>

                        {isSubmitting && <MDProgress show/>}

                        <Button color="green" disabled={!isValid || isSubmitting} block><i className="fa fa-edit"/> Save Changes</Button>

                    </Form>

                }}
            </Formik>
        </SmartDialog>

    }

}

class Settings extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            settings: [],
            error: null,
            searchKeyword: null,
            isBusy: false
        };

        //  get proxy reference
        this.proxy = TTLProxy.getInstance();
    }

    getColumns(){

        const me = this;

        return [
            { key : 'name', label: 'Name'  },
            { key : 'value', label: 'Value'  },
            { key : 'category', label: 'Category'  },
            { key : 'last_updated', label: 'Modified', cell: (item) => (item.date_created !== item.last_updated) ? <TimeAgo id={`modification-date-${item.id}`}  date={item.last_updated}/>  : "Not yet" },
            { key: '__actions', label: ' ' , cell: (item) => {
                    return <ButtonGroup>
                        <Button color="link" onClick={() => me._editDialog.show(item) }><i className="fa fa-edit"/> Edit</Button>
                    </ButtonGroup>
                }}
        ];
    }

    loadSettings(){

        this.setState({
            isBusy: true,
            error: null
        });

        //  fetch settings from server
        return this.proxy.processRequest(MiscEndpoints.getSettings()).then(settings =>{

            this.setState({
                settings: settings.getPayload(),
                isBusy: false,
                error: null
            });

        }).catch(err => {

            this.setState({
                isBusy: false,
                error: Utils.getResponseError(err)
            });

        });
    }

    componentDidMount() {
        return this.loadSettings();
    }

    render(){

        const { settings , isBusy , error } = this.state;

        return <DocumentTitle title="Settings">
            <div style={Styles.contentFrame}>

                <div className="clearfix" style={Styles.heading}>

                    <div className="pull-left">
                        <h5><i className="fa fa-cogs"/> Settings</h5>
                    </div>

                    <div className="pull-right">
                        <ButtonGroup>
                            <Button onClick={() => this.loadSettings()}><i className="fa fa-refresh"/> Refresh</Button>
                        </ButtonGroup>
                    </div>

                </div>

                {isBusy ? <div className="p-lg-5 text-center">
                    <MDSpinner size={32}/>
                    <p>Fetching settings, please hold on...</p>
                </div> :  (error ? <div className="p-lg-5 text-center error-hint" >
                    <div><i className="fa fa-warning fa-3x"/></div>
                    <p>{error}</p>
                </div>  : <JsonTable columns={this.getColumns()} className="table table-hover table-outline table-responsive" rows={settings} settings={{
                    noRowsMessage: 'No settings available...'
                }}/>)}

                {isBusy && <div style={{width: '100%'}}>
                    <ProgressBar show={true}/>
                </div>}

                <EditSettingDialog ref={r => this._editDialog = r} onEdited={() => this.loadSettings()}/>

            </div>
        </DocumentTitle>
    }

}

export default Settings;


// WEBPACK FOOTER //
// ./src/views/Management/Settings/Settings.js